import { useEffect, useState } from "react";
import "./style.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { linksForRoles } from "./menuLinks";
import Menu from "../../assets/icon/Menu";
import Logo from "../../assets/icon/Logo";
import Close from "../../assets/icon/Close";
import ShopButton from "../../assets/icon/ShopButton";
import FooterLinks from "../footer/components/FooterLinks";
import silpoIcon from "../../assets/ic24-silpo.png";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import {
  selectMainState,
  setFeedbackModal,
  setSEOSettings,
} from "../../store/slices/main";
import MasterCard from "../../assets/icon/MasterCard";
import ControlButton from "../common/player/components/ControlButton";
import LogoDesctop from "../../assets/icon/LogoDesctop";
import MobileHeaderPlayer from "./headerPlayer/mobileHeadeerPlayer/MobileHeadeerPlayer";

export default function Header() {
  const dispatch = useAppDispatch();
  const {
    SEOSettingsDefault,
    radioPlayer: { player },
  } = useAppSelector(selectMainState);
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();
  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string
  ) => {
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  useEffect(() => {
    const toggleScroll = () => {
      document.body.style.overflow = isNavOpen ? "hidden" : "auto";
    };
    toggleScroll();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isNavOpen]);

  const closeMenu = () => {
    setIsNavOpen(false);
  };

  return (
    <div className="MOBILE-MENU w-full h-full flex relative items-start">
      <div
        className="HAMBURGER-ICON absolute left-1 top-1 mt-5 m-4 bg-light_gray bg-opacity-30 rounded-md"
        onClick={() => setIsNavOpen((prev) => !prev)}
      >
        <div className="p-2.5">
          <Menu />
        </div>
      </div>
      <div className="SHOP-ICON absolute right-0 top-0 p-4 bg-opacity-30 rounded-md">
        {player && <ControlButton main={true} player={player} />}
      </div>

      <div
        className={`mobileMenu hidden-menu absolute w-[80%] h-screen left-0 flex flex-col justify-evenly z-50 bg-white p-4 shadow transition-all duration-300 ${
          isNavOpen
            ? "opacity-100 transform translate-x-0"
            : "opacity-0 transform -translate-x-full"
        }`}
      >
        <div className="absolute left-1 -top-4 p-4">
          <div className="flex justify-center items-center w-full">
            <div onClick={closeMenu} className="pr-2.5 pt-1.5">
              <Link to="/">
                <Logo width="70" />
              </Link>
            </div>
          </div>
        </div>

        <div
          className="CROSS-ICON absolute top-2 right-2 p-[0.3rem] bg-light_gray bg-opacity-30 rounded-md"
          onClick={() => setIsNavOpen(false)}
        >
          <Close />
        </div>

        <ul className="MENU-LINK-MOBILE-OPEN flex flex-col absolute top-12 left-0 pt-4">
          {Object.values(linksForRoles.Admin).map(
            ({ title, path, icon }, index, array) => {
              const isLast = index === array.length - 1;
              return (
                <li
                  onClick={() => {
                    if (isLast) {
                      dispatch(setFeedbackModal(true));
                    } else {
                      navigateAndSetSEOSettings(path, title, title, "");
                    }
                  }}
                  key={title}
                >
                  <div
                    className="flex flex-row w-full items-center h-11 focus:outline-none hover:bg-lightGray hover:border-l-2 pr-6"
                    onClick={closeMenu}
                  >
                    <span className="inline-flex justify-center items-center ml-4">
                      <img
                        className="w-8 h-auto cursor-pointer"
                        src={icon}
                        alt={title}
                      />
                    </span>
                    <span className="ml-4 text-base font-semibold tracking-wide truncate w-full">
                      {title}
                    </span>
                  </div>
                </li>
              );
            }
          )}
        </ul>
        <div className="absolute left-0 bottom-0 w-full bg-form_bg ">
          <div className="pl-4 pt-4">
            <div className="flex items-center pb-7">
              <img className="w-8 h-8" src={silpoIcon} alt="silpo" />
              <div className="pl-4 ">
                <span className="text-sm opacity-50">Завантажити</span>
                <div>
                  <Link to="/">Мобільний додаток Сільпо</Link>
                </div>
              </div>
            </div>
            <div className="flex items-center pb-7">
              <ShopButton />
              <div className="pl-4">
                <span className="text-sm opacity-50">Перейти до покупок</span>
                <div>
                  <Link to="https://silpo.ua/" target="_blank">
                    silpo.ua
                  </Link>
                </div>
              </div>
            </div>

            <div className="flex pb-3">
              <FooterLinks />
            </div>
          </div>
        </div>
      </div>

      <div className=" flex justify-center items-start w-full">
        <div
          onClick={() => {
            if (SEOSettingsDefault) {
              navigateAndSetSEOSettings(
                "/",
                SEOSettingsDefault.appTitle,
                SEOSettingsDefault.appDescription,
                ""
              );
            }
          }}
          className="w-full max-w-[7rem] h-auto flex justify-center items-center cursor-pointer pt-4"
        >
          {SEOSettingsDefault?.headerImg ? (
            <img src={SEOSettingsDefault?.headerImg} alt="logo" />
          ) : (
            <LogoDesctop />
          )}
        </div>
        {location.pathname === "/schedryk" && (
          <div className="pl-2.5 border-l-2 border-light_gray">
            <MasterCard width="53" height="35" />
          </div>
        )}
      </div>
      <div className="absolute bottom-0 left-0 w-full">
        <div className="p-4">
          <MobileHeaderPlayer />
        </div>
      </div>
    </div>
  );
}
